var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGovernmentBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8,22v-8h2v6.512c0-1.952.777-3.854,2-5.365v-1.147h1.893c-.315-.61-.525-1.281-.525-2v-2h7.765c-.178-.178-.373-.341-.602-.466l-8.183-4.464c-.069-.038-.147-.054-.219-.086v-.958l3-1.944L10.129,0v4.884c-.163.053-.327.105-.479.188L1.469,9.534c-.906.493-1.469,1.441-1.469,2.474v1.992h2v8H0v2h11.257c-.477-.577-.82-1.261-1.03-2h-2.227Zm-4-8h2v8h-2v-8Zm20,7.014c0,1.649-1.343,2.986-3,2.986h-6c-1.657,0-3-1.337-3-2.986,0-2.871,2.273-5.752,4.84-6.452-.706-.667-1.472-1.608-1.472-2.562h5.263c0,.954-.766,1.896-1.472,2.562,2.567.699,4.84,3.581,4.84,6.452Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernmentBudget);
export default __webpack_public_path__ + "static/media/government-budget.da4514a55694bb87ac5a97f361e0c2a0.svg";
export { ForwardRef as ReactComponent };